import React from "react";
import PropTypes from "prop-types";

const ModalPageBody = ({ children, hasStickyFooter = true }) => {
  return (
    <div className={`modal-page__body${hasStickyFooter ? " with-sticky-footer" : ""}`}>
      {children}
    </div>
  );
};

ModalPageBody.propTypes = {
  children: PropTypes.node.isRequired,
  hasStickyFooter: PropTypes.bool,
};

export default ModalPageBody;
